export enum TabType {
  Outdoor = 0,
  Indoor = 1,
  Explore = 2,
  Character = 3,
}

export const TabMappedToRoom: Record<number, string> = {
  0: "Yard",
  1: "Home",
  2: "PlayRoom",
  3: "CalmRoom",
};

// Matches mobile's groupBlocksByName keys used in roomIntroConversations
export const TabToRoomBlockName: Record<TabType, string> = {
  [TabType.Outdoor]: "Outdoor",
  [TabType.Indoor]: "HomePage",
  [TabType.Explore]: "FunRoom",
  [TabType.Character]: "CalmRoom",
};

export interface ConversationObject {
  content: string;
  textColor?: string;
  audio?: string;
  duration?: string; // milliseconds as string
  characterImage?: string; // image URL (Lottie or PNG)
  tapIndicator?: string;
  blockObjects?: { name: string; url: string }[];
  templateElements?: any[];
}

export interface Conversation {
  object: ConversationObject[];
}

export interface UserAction {
  component: "block.text-input" | "block.button-input" | string;
  buttonText: string;
  inputName?: string;
  linkTo?: string;
}

export interface Block {
  id?: string;
  name?: string;
  blockType?: string;
  template?: string;
  order?: number;
  conversations: Conversation[];
  userActions?: UserAction[];
  bgImage?: string;
  bgImageTab?: string;
  templateObjects?: any[];
}

export interface StoryData {
  storyId?: string;
  documentId?: string;
  isOnboardingCompleted: boolean;
  order?: number;
  blocks?: Block[];
  finalTransformedJourneyPage?: { blocks: Block[] };
  roomIntroConversations?: { blocks: Block[] };
  preLimitConversation?: Block;
  onBoardingDoodle?: string;
  lockedTimer?: string;
}

export interface RoomProps {
  storyData: StoryData | null;
  activeBlock: Block | null; // resolved by Rooms/index — correct block for this tab
  conversationIndex: number;
  objectIndex: number;
  onUserAction?: (action: UserAction) => void;
  onNavigateToJourney?: () => void;
  /** Switches the active tab inside the Rooms parent (used by in-room home button). */
  onTabChange?: (tab: TabType) => void;
  /** Called after the user submits a text-input answer — parent should re-fetch story. */
  onInputSubmit?: (value: string) => void;
  /** Called after the user submits hobby selections. */
  onTemplateSubmit?: (template: { name: string; status: boolean }[]) => void;
  /** Called when the user taps a button-input action (no text value). */
  onButtonAction?: () => void;
  /** Notifies parent which element the tap indicator is pointing at (null = hide). */
  onTapIndicator?: (name: string | null) => void;
  onShowOnboardingNavBar?: (values: { url: string; name: string; indicatorType: string }) => void;
}

export const childOnboardingTemplateType = {
  yard: "OnBoarding",
  onBoardingYard: "OnBoardingYard",
  home: "OnBoardingHome",
  funRoom: "OnBoardingFunRoom",
  calmCorner: "OnboardingCalmCorner",
  OnboardingCalmRoom: "OnboardingCalmRoom",
  OnBoardingPlayRoom: "OnBoardingPlayRoom",
  OnBoardingWelcomeRoom: "OnBoardingWelcomeRoom",
  OnBoardingBalloon: "OnBoardingBalloon",
};
